import { Outlet } from "react-router-dom";

const SignupInterface = () => {
  return <Outlet />;
};

export default SignupInterface;
